import React, { memo } from 'react';
import { useAppContext } from '../../contexts/AppContext/AppContext';
import { PageManagementBlock, isPageManagementBlock } from '../../_blocks/PageManagement';
import { BreadcrumbBlock, isBreadcrumbBlock } from '../../_blocks/Breadcrumb';

export type BreadcrumbSection = {
  blocks: [BreadcrumbBlock, PageManagementBlock];
  uuid: string;
};
export const BreadcrumbSection = memo(
  function ({ blocks }: BreadcrumbSection) {
    BreadcrumbSection.displayName = 'BreadcrumbSection';
    const { availableSections } = useAppContext();

    const breadcrumbBlock = blocks.find(isBreadcrumbBlock);
    const pageManagementBlock = blocks.find(isPageManagementBlock);
    return (
      <div className="content-main content-main--breadcrumb-section">
        <div className="content-column-two-third">{breadcrumbBlock && <BreadcrumbBlock {...breadcrumbBlock} />}</div>
        {availableSections.pageManagement && (
          <div className="content-column-one-third">
            {pageManagementBlock && <PageManagementBlock {...pageManagementBlock} />}
          </div>
        )}
      </div>
    );
  },
  (prevProps, nextProps) => prevProps.uuid === nextProps.uuid,
);
